import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { DashboardModuleGuard } from './guards/dashboard-module.guard';
import { TransactionProcessingComponent } from './click-it/create-order/cement/payment/transaction-processing/transaction-processing.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'processing',
    component: TransactionProcessingComponent,
  },
  {
    path: 'terms',
    component: TermsAndConditionsComponent
  },{
    path: '',
    loadChildren: () =>
      import('../app/click-it/click-it.module').then((m) => m.ClickItModule),
    canLoad: [DashboardModuleGuard],
  }
];
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
